import { useMemo } from 'react';

const useMemoOnce = <T>(factory: () => T) => useMemo<T>(factory, []);

export default useMemoOnce;